import Axios from 'axios';
import Qs from 'qs';

export default {

  // 车辆分页列表
  listPage(
    car_number,
    mobile,
    state,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/cars', {
      params: {
        car_number,
        mobile,
        state,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 审核
  review(
    id
  ) {
    return Axios.post(`/community/api/admin/cars-approved/${id}`);
  },

  // 驳回
  overrule(
    id
  ) {
    return Axios.post(`/community/api/admin/cars-rejection/${id}`);
  },

  // 车辆信息
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/cars/${id}`);
  },

}